import employmentDictionary from '@widgets/employment/i18n/ru/employment.dic.json';

export const employment = {
  EMPLOYMENT: employmentDictionary,
};

export const employmentNamespaces = Object.keys(employment);
